<template>
    <div class="PexelsTab p-3">
        <div class="SearchArea">
            <input type="search" @input="onChange($event)" :value="selectedValue"
                class="form-control rounded-pill h-45px" placeholder="Search ... " />
        </div>
        <div class="imagsGallery">
            <h5 class="text-muted py-2">Pexel Photos</h5>
            <!-- <div class="wrapperDiv addpositionRelative" v-if="isImagesLoading === true">
                <div class="imageLoader ">
                 <LoaderSpinner></LoaderSpinner>
                </div> 
            </div> -->
            <!-- <div  @scroll="handleScroll" :class="`showImgs containerimg  ${isImagesLoading === true ? 'hidevisibility' : ''}`" id="masonry-grid"> -->
            <div @scroll="handleScroll" :class="`showImgs containerimg  `" id="masonry-grid">
                <div class="grid-sizer"></div>
                <div class="column" v-for="(item, index) of imglist" v-bind:key="index">

                    <a v-if="item.src" :draggable="true" @dragstart="dragElement($event, item.src?.original, index)"
                        class="imgss" href="javascript:;"
                        @click="addImageinCanvas(item.src?.original + '?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', index)">

                        <img @load="handleLoad" @error="handleLoad" crossorigin="anonymous" class=""
                            :src="`${item.src?.original}?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940`" alt="" />

                    </a>
                    <a v-else :draggable="true" @dragstart="dragElementVideo($event, item.video_files[2].link, index)"
                        class="videoss position-relative d-inline-block" href="javascript:;"
                        @click="addVideoinCanvas(item.video_files[2].link, index)">

                        <img @load="handleLoad" @error="handleLoad" crossorigin="anonymous" class=""
                            :src="`${item.video_pictures[0].picture}`" alt="" />
                        <span class="Showduration">{{ toHHMMSS(item.duration) }}</span>
                    </a>
                </div>


            </div>

        </div>
    </div>
</template>

<script>
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
// import Masonry from "masonry-layout";
// import LoaderSpinner from "../../utils/TabLoader.vue";
import { debounce } from "lodash";


export default {
    name: "PexelsTab",
    data() {
        return {
            imglist: [],
            isImagesLoading: true,
            currentPage: 0,
            searchCurrentPage: 0,
            selectedValue: '',
            imageLoadCount: 0,
            pixelapiToken: "563492ad6f91700001000001b5397606aad14a69a645681988f3a8cc",
            debouncedSearch: debounce(this.searchData, 500),
        }
    },
    components: {
        // LoaderSpinner
    },
    mounted() {
        this.getImgs();

    },
    computed: {
        getActiveCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
    },
    methods: {
        handleLoad() {
            this.imageLoadCount++;
            // if(this.imageLoadCount === this.imglist.length) {
            //     this.initmasnory();
            // }
        },
        onChange(e) {
            let value = e.target.value;
            this.selectedValue = value;
            if (value === '') {
                this.imglist = [];
                this.searchCurrentPage = 0
            }
            this.debouncedSearch(value);
        },
        searchData(query) {
            console.log(query)
            if (query === "") {
                this.getImgs();
            } else {

                this.searchImages(query)
            }
        },
        handleScroll() {
            const container = this.$el.querySelector("#masonry-grid");
            const scrollPosition = container.scrollTop + container.clientHeight;
            const totalHeight = container.scrollHeight;

            // Adjust the threshold as needed
            if (scrollPosition >= totalHeight - 200) {
                // Fetch more images when the user is near the bottom
                if (this.selectedValue === '') {

                    this.getImgs();
                } else {
                    this.searchImages(this.selectedValue)
                }
            }
        },

        //     initmasnory(){
        //     var grid = document.querySelector('#masonry-grid');
        //     new Masonry(grid, {
        //         // options...
        //         columnWidth: '.grid-sizer',
        //         itemSelector: '.column',
        //         percentPosition: true,
        //         gutter: 10

        //     });
        //     this.isImagesLoading = false;

        //    },
        toHHMMSS(secs) {
            var sec_num = parseInt(secs, 10)
            var hours = Math.floor(sec_num / 3600)
            var minutes = Math.floor(sec_num / 60) % 60
            var seconds = sec_num % 60

            return [hours, minutes, seconds]
                .map(v => v < 10 ? "0" + v : v)
                .filter((v, i) => v !== "00" || i > 0)
                .join(":")
        },

        searchImages(query) {
            // this.isImagesLoading = true;
            this.searchCurrentPage++;
            var pixelUrl = "https://api.pexels.com/v1/search?query=" + query + '&page=' + this.searchCurrentPage + '&per_page=50';
            var videosURL = "https://api.pexels.com/videos/search?query=" + query + '&page=' + this.searchCurrentPage + '&per_page=50';
            // var pixelUrl = "https://api.pexels.com/v1/collections/9mp14cx?per_page=1";


            let self = this;
            axios({
                method: 'get',
                url: pixelUrl,
                headers: {
                    "Authorization": this.pixelapiToken,
                }
            })
                .then(function (response) {
                    if (self.searchCurrentPage === 1) {
                        self.imglist = [...response.data.photos];
                    } else {
                        self.imglist = [...self.imglist, ...response.data.photos];
                    }

                    self.imglist = self.imglist.sort(function () {
                        return Math.random() * 2 - 1;
                    });
                    console.log(self.imglist)

                    // self.$nextTick(function () {
                    // //    setTimeout(() => {
                    //      self.initmasnory();
                    // //    }, 3000);

                    // })

                });
            axios({
                method: 'get',
                url: videosURL,
                headers: {
                    "Authorization": this.pixelapiToken,
                }
            })
                .then(function (response) {

                    if (self.searchCurrentPage === 1) {
                        self.imglist = [...response.data.videos];
                    } else {
                        self.imglist = [...self.imglist, ...response.data.videos];
                    }
                    self.imglist = self.imglist.sort(function () {
                        return Math.random() * 2 - 1;
                    });
                    console.log(self.imglist)
                });

        },

        getImgs() {
            // this.isImagesLoading = true;
            this.currentPage++;
            var pixelUrl = "https://api.pexels.com/v1/search?query=trending?" + '&page=' + this.currentPage + '&per_page=50';
            var videosURL = "https://api.pexels.com/videos/popular?" + '&page=' + this.currentPage + '&per_page=50';
            // var pixelUrl = "https://api.pexels.com/v1/collections/9mp14cx?per_page=1";

            let self = this;
            axios({
                method: 'get',
                url: pixelUrl,
                headers: {
                    "Authorization": this.pixelapiToken,
                }
            })
                .then(function (response) {

                    self.imglist = [...self.imglist, ...response.data.photos];
                    self.imglist = self.imglist.sort(function () {
                        return Math.random() * 2 - 1;
                    });
                    console.log(self.imglist)

                    // self.$nextTick(function () {
                    // //    setTimeout(() => {
                    //      self.initmasnory();
                    // //    }, 3000);

                    // })

                });
            axios({
                method: 'get',
                url: videosURL,
                headers: {
                    "Authorization": this.pixelapiToken,
                }
            })
                .then(function (response) {


                    self.imglist = [...self.imglist, ...response.data.videos];
                    self.imglist = self.imglist.sort(function () {
                        return Math.random() * 2 - 1;
                    });
                    console.log(self.imglist)
                });

        },
        dragElement(e, link) {

            let obj = {
                id: `Photos_${uuidv4()}`,
                type: 'img',
                // top:150,
                // left:150,
                rotate: 0,
                top: 0,
                left: 0,
                scaleX: 1,
                scaleY: 1,
                zoom: 1,
                // width:150,
                // height:100,
                width: this.getActiveCanvas.size.width,
                height: this.getActiveCanvas.size.height,
                opacity: 1,
                lock: false,
                borderRadius: 0,
                url: link,
                brightness: 100,
                contrast: 100,
                saturation: 100,
                animationClassIn: "",
                animationClassOut: "",
                animationClass: "",
                animationClassLoop: "",
                animationDelay: 0,
                animationDuration: 2,
                animationDelayIn: 0,
                animationDurationIn: 2,
                animationDelayOut: 0,
                animationDurationOut: 2,
                animationLoopDuration: 2,
                orientation: 0,
                adjustment: 'cover',
                animationLoop: false
            };
            var j = JSON.stringify(obj);
            e.dataTransfer.setData("imgs", j);
        },
        dragElementVideo(e, link) {

            let obj = {
                id: `video_${uuidv4()}`,
                type: 'video',
                rotate: 0,
                // top:200,
                // left:200,
                top: 0,
                left: 0,
                scaleX: 1,
                scaleY: 1,
                zoom: 1,
                // width:150,
                // height:100,
                width: this.getActiveCanvas.size.width,
                height: this.getActiveCanvas.size.height,
                opacity: 1,
                lock: false,
                borderRadius: 0,
                url: link,
                animationClassIn: "",
                animationClassOut: "",
                animationClass: "",
                animationClassLoop: "",

                animationDelay: 0,
                animationDuration: 2,
                animationDelayIn: 0,
                animationDurationIn: 2,
                animationDelayOut: 0,
                animationDurationOut: 2,
                animationLoopDuration: 2,
                animationLoop: false
            };
            var j = JSON.stringify(obj);
            e.dataTransfer.setData("imgs", j);
        },
        addVideoinCanvas(url) {


            this.$store.dispatch("addObjectInCanvas",
                {
                    id: `video_${uuidv4()}`,
                    type: 'video',
                    rotate: 0,
                    // top:200,
                    // left:100,
                    top: 0,
                    left: 0,
                    scaleX: 1,
                    scaleY: 1,
                    zoom: 1,
                    // width:150,
                    // height:100,
                    width: this.getActiveCanvas.size.width,
                    height: this.getActiveCanvas.size.height,
                    opacity: 1,
                    lock: false,
                    borderRadius: 0,
                    url: url,
                    isInAnimationActive: false,
                    isOutAnimationActive: false,
                    isLoopAnimationActive: false,
                    AnimationSequence: [],
                    animationClassIn: "",
                    animationClassOut: "",
                    animationClass: "",
                    animationClassLoop: "",
                    animationDelay: 0,
                    animationDuration: 2,
                    animationDelayIn: 0,
                    animationDurationIn: 2,
                    animationDelayOut: 0,
                    animationDurationOut: 2,
                    animationLoopDuration: 2,
                    animationLoop: false
                },
            )
        },
        addImageinCanvas(link) {

            this.$store.dispatch("addObjectInCanvas",
                {
                    id: `Photos_${uuidv4()}`,
                    type: 'img',
                    // top:150,
                    // left:150,
                    rotate: 0,
                    top: 0,
                    left: 0,
                    scaleX: 1,
                    scaleY: 1,
                    zoom: 1,
                    // width:150,
                    // height:100,
                    width: this.getActiveCanvas.size.width,
                    height: this.getActiveCanvas.size.height,
                    opacity: 1,
                    lock: false,
                    borderRadius: 0,
                    url: link,
                    brightness: 100,
                    contrast: 100,
                    saturation: 100,
                    isInAnimationActive: false,
                    isOutAnimationActive: false,
                    isLoopAnimationActive: false,
                    AnimationSequence: [],
                    animationClassIn: "",
                    animationClassOut: "",
                    animationClass: "",
                    animationClassLoop: "",
                    animationDelay: 0,
                    animationDuration: 2,
                    animationDelayIn: 0,
                    animationDurationIn: 2,
                    animationDelayOut: 0,
                    animationDurationOut: 2,
                    animationLoopDuration: 2,
                    orientation: 0,
                    adjustment: 'cover',
                    animationLoop: false
                },
            )
        }


    },

}
</script>
<!-- <style scoped>
.containerimg {
    height: 95vh;
    overflow-y: scroll;
}
.Showduration{
    position:absolute;
    bottom: 5px;
    right: 5px;
    font-size: 9px;
    font-weight: 600;
    color: #fff;
    background-color: rgba(0,0,0,0.75);
    padding: 1px 5px;
    border-radius: 3px;

}
#flexbox {
    display: flex;
    flex-wrap: wrap;
    padding: 0 4px;
}

.column {
    flex: 50%;
    max-width: 50%;
    padding: 0 4px;
}

.column img {
    vertical-align: middle;
    margin-top: 8px;
    width: 100%;

}

.column:nth-child(even) {
    display: flex;
    flex-direction: column-reverse;
}
</style> -->
<style scoped>
/* .containerimg {
  display: flex;
  flex-wrap: wrap;
} */

.containerimg {
    /* height: 95vh !important; */
    height: calc(100vh - 258px) !important;

    overflow-y: scroll;
}

.column {
    display: block;
    width: 100%;
    /* Adjust as needed */
    box-sizing: border-box;
    padding: 5px;
    /* Adjust as needed */
    text-align: center;
}

.grid-sizer {
    width: 50%;
}

.column img {
    width: 100%;
    height: auto;
    border-radius: 5px;
}

.addPositionAbsolute {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.addpositionRelative {
    position: relative;
    height: 100vh;
}

.imageLoader {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.imagsGallery {
    position: relative;
}

.hidevisibility {
    visibility: hidden;
    position: fixed;
    top: 0;
}

.Showduration {
    position: absolute;
    bottom: 5px;
    right: 5px;
    font-size: 9px;
    font-weight: 600;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.75);
    padding: 1px 5px;
    border-radius: 3px;

}
</style>